/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getSelectedGlobalContentPath, getSchemaIdForSelectedGlobalModule, getIsSelectedGlobalContentV1 } from 'ContentEditorUI/redux/selectors/globalContentSelectors';
import { getRenderLanguage } from 'ContentEditorUI/redux/selectors/languageSelectors';
import { getHasUnsavedChanges, getIsSaveInProgress } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasGlobalContentEditorAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import Routes from 'ContentUtils/Routes';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import DesignAssetTypes from 'ContentUtils/constants/DesignAssetTypes';
import { closeModal as closeModalAction } from 'ContentEditorUI/redux/actions/appActions';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { selectThemeVariantName } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { selectSelectedTable, selectActiveHubDbRowId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    contentModelId: getContentModelId(state),
    hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state),
    hasUnsavedChanges: getHasUnsavedChanges(state),
    isGlobalContentV1: getIsSelectedGlobalContentV1(state),
    isSaveInProgress: getIsSaveInProgress(state),
    moduleSchemaId: getSchemaIdForSelectedGlobalModule(state),
    renderLanguage: getRenderLanguage(state),
    selectedGlobalContentPath: getSelectedGlobalContentPath(state),
    isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
    selectedHubDBTable: selectSelectedTable(state),
    selectedHubDBRowId: selectActiveHubDbRowId(state),
    selectedThemeVariant: selectThemeVariantName(state)
  };
};
const mapDispatchToProps = {
  closeModal: closeModalAction
};
const getLangKey = key => {
  return `components.modals.globalContentModal.${key}`;
};
const GlobalContentModal = ({
  contentModelId,
  forceLinkToDesignManager,
  fromAppName,
  hasGlobalContentEditorAccess,
  hasUnsavedChanges,
  isGlobalContentV1,
  moduleSchemaId,
  renderLanguage,
  closeModal,
  selectedGlobalContentPath,
  isInDefaultBreakpointMode,
  saveActions,
  selectedHubDBTable,
  selectedHubDBRowId,
  selectedThemeVariant
}) => {
  const [waitingForSave, setWaitingForSave] = useState(false);
  const linkToDesignManager = !hasGlobalContentEditorAccess || forceLinkToDesignManager || isGlobalContentV1;
  const getDesignManagerUrl = () => Routes.designManager(moduleSchemaId, isGlobalContentV1 ? DesignAssetTypes.GLOBAL_WIDGET : DesignAssetTypes.CUSTOM_WIDGET);
  const getGlobalContentEditorUrl = () => {
    const tableId = selectedHubDBTable ? selectedHubDBTable.id : undefined;
    const rowId = !selectedHubDBRowId || selectedHubDBRowId === 0 ? undefined : selectedHubDBRowId;
    const url = Routes.globalContentEditor(undefined, {
      assetPath: selectedGlobalContentPath,
      contentId: contentModelId,
      redirectUrl: window.location.pathname,
      translationLang: renderLanguage,
      fromAppName,
      tableId,
      rowId,
      themeVariant: selectedThemeVariant || undefined
    });
    return url;
  };
  const handleConfirm = () => {
    UsageTracker.trackEditorInteraction({
      action: 'Sidebar Action',
      event: 'global-content-editor-opened'
    });
    let newLocation = linkToDesignManager ? getDesignManagerUrl() : getGlobalContentEditorUrl();
    if (window.SELENIUM_IS_RUNNING) {
      newLocation = `${newLocation}&seleniumRunning=true`;
    }
    if (hasUnsavedChanges) {
      setWaitingForSave(true);
      saveActions.autoSave().then(() => {
        window.location = newLocation;
      });
    } else {
      window.location = newLocation;
    }
  };
  const renderConfirmButton = () => {
    const labelKey = linkToDesignManager ? 'designManagerConfirmLabel' : 'confirmLabel';
    return /*#__PURE__*/_jsx(LoadingButton, {
      loading: waitingForSave,
      use: "primary",
      onClick: handleConfirm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey(labelKey)
      })
    });
  };
  const description = isInDefaultBreakpointMode ? getLangKey('descriptionDesktop') : getLangKey('descriptionMobile');
  if (selectedGlobalContentPath || isGlobalContentV1 && moduleSchemaId) {
    return /*#__PURE__*/_jsx(ConfirmModal, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('title')
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: description
      }),
      ConfirmButton: renderConfirmButton,
      onConfirm: handleConfirm,
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('rejectLabel')
      }),
      onReject: closeModal,
      size: "auto"
    });
  }
  return null;
};
GlobalContentModal.propTypes = {
  contentModelId: PropTypes.number,
  forceLinkToDesignManager: PropTypes.bool,
  fromAppName: PropTypes.string,
  hasGlobalContentEditorAccess: PropTypes.bool.isRequired,
  hasUnsavedChanges: PropTypes.bool.isRequired,
  isGlobalContentV1: PropTypes.bool.isRequired,
  moduleSchemaId: PropTypes.number,
  renderLanguage: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  selectedGlobalContentPath: PropTypes.string,
  isInDefaultBreakpointMode: PropTypes.bool.isRequired,
  saveActions: PropTypes.object.isRequired,
  selectedHubDBRowId: PropTypes.number,
  selectedHubDBTable: PropTypes.number,
  selectedThemeVariant: PropTypes.string
};
export default connect(mapStateToProps, mapDispatchToProps)(withEditorActionsAndEvents(GlobalContentModal));